/** Default dashboard profile avatar when no custom photo is set. */
export const DASHBOARD_PROFILE_AVATAR = '/dashboard/profile-avatar-icon.png';
